import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

//
export default function ArrowUnderMenu(props: any) {
    return (
        <>
            <ArrowDropDownIcon sx={props.sx} style={{ transform: props.open ? "scaleY(-1)" : " scaleY(1)" }} />
        </>
    );
} 